import { render, staticRenderFns } from "./BusinessCreateEdit.vue?vue&type=template&id=30642b0e"
import script from "./BusinessCreateEdit.vue?vue&type=script&lang=js"
export * from "./BusinessCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports